















































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class ReportDashboardComponent extends Vue {

    // show report
    showReport(name: string) {
        this.$router.push({
            name
        });
    }

}
